export default {
  state: {
    IN_PROGRESS: 'inProgress',
    COMPLETED: 'completed',
    FAILED: 'failed',
    UPLOADING: 'uploading'
  }
}
